import type {AutocompleteDiscussion, AutocompleteIssue, AutocompletePullRequest} from '@github-ui/copilot-chat-types'
import {reactFetchJSON} from '@github-ui/verified-fetch'

const ISSUES_PATH = '/copilot/chat/autocomplete/issues'
const PULLS_PATH = '/copilot/chat/autocomplete/pulls'
const DISCUSSIONS_PATH = '/copilot/chat/autocomplete/discussions'

export async function fetchAutocompleteIssues(
  nwo: string,
  filter: string,
  signal?: AbortSignal,
): Promise<AutocompleteIssue[]> {
  const params = new URLSearchParams({repo: nwo, q: filter})
  const response = await reactFetchJSON(`${ISSUES_PATH}?${params}`, {method: 'GET', signal})
  if (!response.ok) throw new Error(`Failed to load issues (${response.status})`)
  return (await response.json()) as AutocompleteIssue[]
}

export async function fetchAutocompletePulls(
  nwo: string,
  filter: string,
  signal?: AbortSignal,
): Promise<AutocompletePullRequest[]> {
  const params = new URLSearchParams({repo: nwo, q: filter})
  const response = await reactFetchJSON(`${PULLS_PATH}?${params}`, {method: 'GET', signal})
  if (!response.ok) throw new Error(`Failed to load pull requests (${response.status})`)
  return (await response.json()) as AutocompletePullRequest[]
}

export async function fetchAutocompleteDiscussions(
  nwo: string,
  filter: string,
  signal?: AbortSignal,
): Promise<AutocompleteDiscussion[]> {
  const params = new URLSearchParams({repo: nwo, q: filter})
  const response = await reactFetchJSON(`${DISCUSSIONS_PATH}?${params}`, {method: 'GET', signal})
  if (!response.ok) throw new Error(`Failed to load discussions (${response.status})`)
  return (await response.json()) as AutocompleteDiscussion[]
}
